import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { ListingArg } from './types';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/ListingCardClickstreamEvents.ts';

export type ListingCardTriggerLocation = 'search_results_feed' | 'search_results_list' | 'search_results_map';

const PROPERTY_CARD_IMPRESSION = defineHotpadsEvent({
  key: 'listing_card.impression',
  eventTypeId: '5601',
  eventTypeVersionId: '2',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackImpressionForPropertyCardEvent',
  trigger: {
    type: 'impression',
    location: 'search_results_list',
    source: 'property_card',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const CLICK_INTO_PROPERTY = defineHotpadsEvent({
  key: 'listing_card.click_into_property',
  eventTypeId: '9460',
  eventTypeVersionId: '3',
  eventTemplateId: '534',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackClicksIntoPropertyEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results_list',
    source: 'button_to_see_listing_details',
    object: 'property_card',
  },
  semanticEvent: 'clicks_into_property',
});

export function emitTrackImpressionForPropertyCardEvent({
  listing,
  triggerLocation,
}: ListingArg & { triggerLocation: ListingCardTriggerLocation }) {
  trackHotpadsEventDefinition(PROPERTY_CARD_IMPRESSION, { listing, triggerLocation });
}

export function emitTrackClicksIntoPropertyEvent({
  listing,
  triggerLocation,
}: ListingArg & { triggerLocation: ListingCardTriggerLocation }) {
  trackHotpadsEventDefinition(CLICK_INTO_PROPERTY, { listing, triggerLocation });
}
